/**
 * Global fetch interceptor for admin impersonation
 * This intercepts ALL fetch calls and automatically adds X-Impersonate-User header if impersonating
 */
import { config } from '../config'

// Store the original fetch
const originalFetch = window.fetch;

// Flag to prevent infinite loops
let isInterceptorActive = false;

/**
 * Install the fetch interceptor
 */
export const installFetchInterceptor = () => {
  if (isInterceptorActive) {
    return; // Already installed
  }

  window.fetch = async (...args) => {
    const [url, options = {}] = args;
    
    // Check if we're impersonating (stored as user ID, not token)
    const impersonateUserId = localStorage.getItem('admin_impersonate_user_id');
    
    const urlString = typeof url === 'string' ? url : url.toString();

    if (impersonateUserId) {
      // Determine if the request targets our backend (by base URL), not just path fragments
      const apiBase = config.API_BASE_URL; // e.g., http://localhost:8000
      let isBackendCall = false;
      try {
        const requestUrl = new URL(urlString, window.location.origin);
        const backendUrl = new URL(apiBase);
        isBackendCall = (requestUrl.protocol === backendUrl.protocol && requestUrl.host === backendUrl.host);
      } catch (e) {
        // Fallback if URL parsing fails (relative paths or unusual inputs)
        isBackendCall = urlString.startsWith(apiBase);
      }

      // Admin endpoints should not be impersonated; they must use real admin auth
      const isAdminEndpoint = urlString.includes('/api/admin/');

      if (isBackendCall && !isAdminEndpoint) {
        // Clone the options to avoid mutating the original
        const modifiedOptions = { ...options };
        const existingHeaders = options.headers || {};
        modifiedOptions.headers = {
          ...existingHeaders,
          'X-Impersonate-User': impersonateUserId,
        };

        return originalFetch(url, modifiedOptions);
      }
    }
    
    // Not impersonating or not an API call - use original fetch
    return originalFetch(...args);
  };
  
  isInterceptorActive = true;
  console.log('✅ Fetch interceptor installed for admin impersonation');
};

/**
 * Uninstall the fetch interceptor
 */
export const uninstallFetchInterceptor = () => {
  window.fetch = originalFetch;
  isInterceptorActive = false;
  console.log('❌ Fetch interceptor uninstalled');
};

